<template>
    <div class="draft-item">
        <h4 class="ell">【{{ item.category_name }}】{{ item.type_name }}</h4>
        <p class="ell">来源: {{ item.source_name }}</p>
        <p class="ell" v-if="item.receive_time">最新接收时间: {{ item.receive_time }}</p>
        <p class="ell" v-if="item.send_time">最新保存时间: {{ item.send_time }}</p>
        <p class="ell" v-if="sourceType == 'sendGridEximpl'">最新办理时间: {{ item.operate_time }}</p>

        <div class="box" @click="handle(item)">
            <h5 class="ell">{{ item.total_count }}</h5>
            <p class="ell">{{ sourceType == "draftsEximpl" ? "草稿数量" : "待办数量" }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DraftItem",
        props: ["item", "sourceType"],
        data() {
            return {
                rsv2: this.$route.query.rsv2,
            }
        },
        created() {
          console.log(this.sourceType,8888);
        },
        methods: {
            handle(item) {
                if (this.rsv2 === 'true') {
                    if (item.source_code != "serviceall") {
                        //跳转实例页面ExampleItem
                        this.$router.push({
                            path: "/ExampleItemData",
                            query: {
                                source_code: item.source_code,
                                type_code: item.type_code,
                                sourceType: this.sourceType,
                            },
                        })
                    } else {
                        location.href = item.total_count_mobile_link
                    }
                } else {
                    if (item.source_code == "serviceall") {
                        location.href = item.total_count_mobile_link
                    } else {
                        window.location.href = item.total_count_mobile_link
                    }
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .draft-item {
        padding: 15px;
        padding-right: 115px;
        margin-bottom: 15px;
        border: 1px solid #e5e5e5;
        border-radius: 5px;
        background: #fff;
        position: relative;
        h4 {
            height: 30px;
            line-height: 30px;
            font-size: 14px;
        }
        p {
            line-height: 20px;
            font-size: 12px;
            color: #999;
        }
        .box {
            width: 85px;
            padding: 10px;
            text-align: center;
            position: absolute;
            right: 15px;
            top: 15px;
            border-radius: 5px;
            background: #f7f7f7;
            h5 {
                height: 30px;
                line-height: 30px;
                margin-bottom: 5px;
                font-weight: bold;
                font-size: 18px;
                color: #1678ff;
            }
            p {
                font-size: 14px;
                color: #333;
            }
        }
    }

    .ell {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
